<req-resp-tab-group>
    <create-subscription-multiple-request class="req-tab">
    </create-subscription-multiple-request>
    <create-subscription-multiple-response class="resp-tab">
    </create-subscription-multiple-response>
</req-resp-tab-group>